import React, { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import QrCodeIcon from '@mui/icons-material/QrCode';
import { QRCodeCanvas } from 'qrcode.react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const QRcode = () => {
    // RecordInfo에서 전달된 state 받아오기
    const location = useLocation();
    const state = (location.state as {
        name?: string;
        bibNumber?: string;
        competitionName?: string;
        personalRecord?: string;
        division?: string;
    }) || {};

    // URL 쿼리파라미터에서 comp_code 와 bib 읽어오기
    const params = new URLSearchParams(location.search);
    const urlComp = params.get('competitions') || '';
    const urlBib  = params.get('bib')      || '';
    const urlName = params.get('name')      || '';
    const urldiv = params.get('div')      || '';

    // 각 필드의 초기값을 전달된 값으로 설정
    const [name, setName] = useState(state.name || urlName || '');
    const [bibNumber, setBibNumber] = useState(state.bibNumber || urlBib ||'');
    // competitionName은 db 업데이트에 사용됨
    const [competitionName, setCompetitionName] = useState(state.competitionName || urlComp ||  '');
    const [personalRecord, setPersonalRecord] = useState(state.personalRecord || '');
    const [division, setDivision] = useState(state.division || urldiv ||'');
    const [cheerMessage, setCheerMessage] = useState(''); // 응원문구
    const [qrData, setQrData] = useState('');
    // IME 입력 상태 플래그
    const [isComposing, setIsComposing] = useState(false);

    // 응원문구 입력 시: IME 작동 여부에 따라 필터링 적용
    const handleCheerMessageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!isComposing) {
            const input = e.target.value;
            // 알파벳, 한글, 숫자, 공백만 허용
            const filtered = input.replace(/[^A-Za-z0-9가-힣\s~!@%,./:""'']/g, '');
            const limited = filtered.slice(0, 16);
            setCheerMessage(limited);
        } else {
            setCheerMessage(e.target.value);
        }
    };

    // IME 입력 시작 시 플래그 설정
    const handleCompositionStart = () => {
        setIsComposing(true);
    };

    // IME 입력 종료 시 필터링 적용 후 플래그 해제
    const handleCompositionEnd = (e: React.CompositionEvent<HTMLInputElement>) => {
        setIsComposing(false);
        const input = (e.target as HTMLInputElement).value || '';
        const filtered = input.replace(/[^A-Za-z0-9가-힣\s]/g, '');
        const limited = filtered.slice(0, 16);
        setCheerMessage(limited);
    };

     // 개인 기록 입력 핸들러: 오직 숫자, 콜론(:), 마침표(.)만 허용
    // 형식은 HH:MM:SS.ms로 입력할 수 있으며, HH는 최대 3자리까지 허용됩니다.
    const handlePersonalRecordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let input = e.target.value;
        // 숫자, 콜론, 마침표만 남김
        input = input.replace(/[^0-9:.]/g, '');
        // 마침표는 단 하나만 허용: 첫번째 마침표 이후 나오는 마침표들을 제거
        const parts = input.split('.');
        if (parts.length > 2) {
        input = parts[0] + '.' + parts.slice(1).join('');
        }
        // 최대 길이 13자로 제한 (예: "123:45:67.890")
        const limited = input.slice(0, 13);
        setPersonalRecord(limited);
    }
    
        const data = `이름: ${name}, 종목: ${division}, 배번호: ${bibNumber}, 기록: ${personalRecord}, 응원: ${cheerMessage}`;

    const handleGenerateQRCode = async () => {
        if (!name || !bibNumber || !division || !personalRecord || !cheerMessage) {
          alert('모든 값을 입력해주세요.');
          return;
        }
        // competitionName이 없으면 "-"를 전송
        const compName = competitionName ? competitionName.trim() : "-";
        const updatePayload = {
          competitionName: compName,
          bib: bibNumber,
          name: name,
          division: division,
          personalRecord: personalRecord,
          cheerMessage: cheerMessage,
        };
      
        try {
          const response = await axios.post('/api/update-record', updatePayload, {
            headers: { 'Content-Type': 'application/json' },
          });
          // 성공적으로 업데이트된 경우, 응답은 response.data에 담깁니다.
          // 추가 처리 필요 시 이곳에서 진행
        } catch (error) {
          // error.response.data.error가 있으면 그것을 사용하고, 그렇지 않으면 error.message를 사용합니다.
          alert(`업데이트 실패: ${error}`);
          return;
        }
        // QR코드에는 bibNumber만 사용
        setQrData(bibNumber);
      };
        // const centeredTextFieldSx = {
        //     '& input': {
        //         textAlign: 'center',
        //     },
        //     '& .MuiInputLabel-root': {
        //         width: '100%',
        //         textAlign: 'center',
        //         left: 0,
        //         transformOrigin: 'center',
        //     },
        //     '& .MuiInputLabel-root.MuiInputLabel-shrink': {
        //         width: '100%',
        //         textAlign: 'center',
        //         left: -10,
        //         transformOrigin: 'center',
        //     },
        // };
        const centeredTextFieldSx = {
    '& input': {
        textAlign: 'center',
    },

    // label 중앙정렬
    '& .MuiInputLabel-root': {
        width: '100%',
        textAlign: 'center',
        left: 0,
        right: 0,
        transformOrigin: 'center',
    },

    // label이 위로 올라갔을 때도 중앙 유지
    '& .MuiInputLabel-root.MuiInputLabel-shrink': {
        transform: 'translate(0, -9px) scale(0.75)',
        transformOrigin: 'center',
    },

    // Outlined TextField의 상단 빈 notch 영역을 중앙으로 이동
    '& .MuiOutlinedInput-notchedOutline legend': {
        marginLeft: 'auto',
        marginRight: 'auto',
        textAlign: 'center',
    },
};
    return (
        <div>
            <div className='flex flex-col gap-8 items-center mb-20'>
                {qrData && (
                    <div className='mt-10 mb-10'>
                        <QRCodeCanvas
                            value={qrData}
                            size={256}
                            level="M"
                            includeMargin={true}
                            bgColor="#FFFFFF"    // 백그라운드 흰색
                            fgColor="#000000"    // 전경(패턴) 검정색
                            />
                            <div className="text-center text-3xl text-red-900">
                            QR코드를 캡쳐하세요!
                            </div>
                    </div>
                )}
                <div className='flex flex-col gap-5 items-center'>
                    <div className='flex justify-end items-center gap-5 w-full'>
                        <div className='text-xl'>이름:</div>
                        <TextField
                            id="name"
                            // label="이름"
                            // variant="filled"
                            
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            sx={centeredTextFieldSx}
                        />
                    </div>
                    <div className='flex justify-end items-center gap-5 w-full'>
                        <div className='text-xl'>종목:</div>
                        <TextField
                            id="division"
                            // label="종목 정보"
                            // variant="filled"
                            value={division}
                            onChange={(e) => setDivision(e.target.value)}
                            sx={centeredTextFieldSx}
                        />
                    </div>
                    <div className='flex justify-end items-center gap-5'>
                        <div className='text-xl'>참가번호:</div>
                        <TextField
                            id="bib-number"
                            // label="참가번호"
                            // variant="filled"
                            value={bibNumber}
                            onChange={(e) => setBibNumber(e.target.value)}
                            sx={centeredTextFieldSx}
                        />
                    </div>
                    <div className='flex justify-end items-center gap-5'>
                        <div className='text-xl'>개인기록:</div>
                        <TextField
                            id="personalRecord"
                            label="HH:MM:SS"
                            // label="개인 기록"
                            // variant="filled"
                            value={personalRecord}
                            // onChange={(e) => setPersonalRecord(e.target.value)}
                            onChange={handlePersonalRecordChange}
                            sx={centeredTextFieldSx}
                        />
                    </div>
                    <div className='flex justify-end items-center gap-5'>
                        <div className='text-xl'>응원문구:</div>
                        <TextField
                            id="cheerMessage"   
                            label="특수문자를 제외한 16글자 이내"
                            variant="filled"
                            value={cheerMessage}
                            onChange={handleCheerMessageChange}
                            onCompositionStart={handleCompositionStart}
                            onCompositionEnd={handleCompositionEnd}
                            sx={centeredTextFieldSx}
                        />
                    </div>
                </div>
                <Button
                    variant="contained"
                    startIcon={<QrCodeIcon />}
                    size='large'
                    onClick={handleGenerateQRCode}
                >
                    메달각인, 포토월 이용 QR코드 생성
                </Button>
            </div>
        </div>
    );
};

export default QRcode;
